/**
 * -------------------------------------------------------
 * NOTE: This is a generated file, do not manually modify!
 * -------------------------------------------------------
 */
export var spacing = {
    '100': { pixels: 2, px: '2px', rem: '0.125rem' },
    '200': { pixels: 4, px: '4px', rem: '0.25rem' },
    '250': { pixels: 6, px: '6px', rem: '0.375rem' },
    '300': { pixels: 8, px: '8px', rem: '0.5rem' },
    '350': { pixels: 10, px: '10px', rem: '0.625rem' },
    '400': { pixels: 12, px: '12px', rem: '0.75rem' },
    '500': { pixels: 16, px: '16px', rem: '1rem' },
    '550': { pixels: 20, px: '20px', rem: '1.25rem' },
    '600': { pixels: 24, px: '24px', rem: '1.5rem' },
    '700': { pixels: 32, px: '32px', rem: '2rem' },
    '750': { pixels: 36, px: '36px', rem: '2.25rem' },
    '800': { pixels: 40, px: '40px', rem: '2.5rem' },
    '900': { pixels: 48, px: '48px', rem: '3rem' },
    '1000': { pixels: 56, px: '56px', rem: '3.5rem' },
    '1100': { pixels: 64, px: '64px', rem: '4rem' },
    '1200': { pixels: 72, px: '72px', rem: '4.5rem' },
    '1300': { pixels: 80, px: '80px', rem: '5rem' },
    '1400': { pixels: 120, px: '120px', rem: '7.5rem' },
};
